import { render, staticRenderFns } from "./inv_category.vue?vue&type=template&id=098709f5"
import script from "./inv_category.vue?vue&type=script&lang=js"
export * from "./inv_category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports